import React, { useEffect, useState } from 'react'
import CustomTitle from '../../components/UI/title/CustomTitle'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import './style.scss';
import MyButton from '../../components/UI/button/MyButton';

import { useSearchBusinessProfilesQuery } from '../../api/dataApi';
import PredictGraphUp from './PredictGraphUp';
import PredictGraphDown from './PredictGraphDown';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';
import { useDispatch } from 'react-redux';
import { setIsShowButton } from '../../store/buttonSlice';
import CryptoJS from 'crypto-js';

export const valueGoal = [
    [
        '30+',
        '70+',
        '150+',
        '500+',
        '1,000+',
        '1,000+',
    ],
    [
        '$5',
        '$10',
        '$20',
        '$50',
        '$100',
        '$100+',
    ],
    [
        '2',
        '4',
        '7',
        '10',
        '15',
        '15',
    ], [
        '5%',
        '10%',
        '15%',
        '20%',
        '30%',
        '30%',
    ],
]

export const valueGoalProductivity = [
    [
        '10+',
        '30+',
        '100+',
        '300+',
        '300+',
    ],
    [
        '$5',
        '$10',
        '$20',
        '$50',
        '$100',
    ],
    [
        '10+',
        '30+',
        '50+',
        '100+',
        '100+',
    ], [
        '$5',
        '$10',
        '$20',
        '$50',
        '$100',
    ], [
        '1',
        '5',
        '10',
        '50',
        '100',
        '100+',
    ], [
        '$100',
        '$200',
        '$500',
        '$1,000',
        '$2,000',
        '$2,000',
    ],
]

export default function Predict({ isStart }) {
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { trackP1Event } = useMixpanel();
    const currentDate = new Date();
    const daysToAdd = parseInt(queryParams.get('days') ?? 28, 10);
    const futureDate = new Date(currentDate.setDate(currentDate.getDate() + daysToAdd));
    const futureMonth = futureDate.toLocaleString('en-US', { month: 'long' });
    const futureYear = futureDate.getFullYear();
    // const weeksToAdd = Math.floor(daysToAdd / 7);
    const weeksToAdd = (queryParams.get('period') ?? 'Week 4')
        .toLowerCase()
        .replace(/^\w/, (c) => c.toUpperCase());

    const secretKey = 'j5wbjG3jNJMCSI9';

    const decryptText = (ciphertext) => {
        const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
        const original = bytes.toString(CryptoJS.enc.Utf8);
        return original;
    };

    const decryptEmail = decryptText(queryParams.get('ue') || "") || "";
    const { data: businessProfiles, error, isLoading } = useSearchBusinessProfilesQuery(decryptEmail);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setIsShowButton(false));
        document.documentElement.style.overflow = 'hidden';
    }, [])

    const goalsId = queryParams.get('goals') ?? '0'
    const targetId = queryParams.get('target-id') ?? '1'


    const titles = [
        `AI copilot will help you reach ${valueGoal[0][targetId]} monthly purchases by ${futureMonth} ${futureYear}`,
        `AI copilot will help you reach  ${targetId != 5 ? 'up to' : ''} ${valueGoal[1][targetId]} CPA by ${futureMonth} ${futureYear}`,
        `AI copilot will help you reach more than ${valueGoal[2][targetId]} ROAS by April 2025`,
        `AI copilot will help you reach  ${targetId != 5 ? 'up to' : 'more than'}  ${valueGoal[3][targetId]} CTR by ${futureMonth} ${futureYear}`,
    ]

    const titlesProductivity = [
        `AI copilot will help you create ${valueGoalProductivity[0][targetId]} video ads every month by ${futureMonth} ${futureYear}`,
        `AI copilot will help you cut video ad creation costs up to ${valueGoalProductivity[1][targetId]} by ${futureMonth} ${futureYear}`,
        `AI copilot will help you create ${valueGoalProductivity[2][targetId]} static ads monthly by ${futureMonth} ${futureYear}`,
        `AI copilot will cut your static ad creation costs up to ${valueGoalProductivity[3][targetId]} monthly by ${futureMonth} ${futureYear}`,
        `AI copilot will help you create ${targetId != 0 ? 'up to' : ''} ${valueGoalProductivity[4][targetId]} ad campaigns monthly by ${futureMonth} ${futureYear}`,
        `AI copilot will help you cut ad handling costs by ${valueGoalProductivity[5][targetId]}/ month by ${futureMonth} ${futureYear}`,
    ]

    const graphTitles = [
        `Monthly purchases`,
        `CPA`,
        `ROAS`,
        `CTR`
    ]

    const graphTitlesProductivity = [
        `Monthly video ads`,
        `Video ad cost`,
        `Monthly static ads`,
        `Static ad cost`,
        `Launch more ad campaigns`,
        `Monthly ad handling cost`
    ]

    const graphGoal = queryParams.get("productivity-goals-id") ? valueGoalProductivity[queryParams.get("productivity-goals-id")][targetId] : valueGoal[goalsId][targetId]
    const graphTitle = queryParams.get("productivity-goals-id") ? graphTitlesProductivity[queryParams.get("productivity-goals-id")] : graphTitles[goalsId]
    const title = queryParams.get("productivity-goals-id") ? titlesProductivity[queryParams.get("productivity-goals-id")] : titles[goalsId]

    const graphs = [
        <PredictGraphUp isStart={isStart} />,
        <PredictGraphDown isStart={isStart} />,
        <PredictGraphUp isStart={isStart} />,
        <PredictGraphUp isStart={isStart} />
    ]

    const graphsProductivity = [
        <PredictGraphUp isStart={isStart} />,
        <PredictGraphDown isStart={isStart} />,
        <PredictGraphUp isStart={isStart} />,
        <PredictGraphDown isStart={isStart} />,
        <PredictGraphUp isStart={isStart} />,
        <PredictGraphDown isStart={isStart} />
    ]

    const graph = queryParams.get("productivity-goals-id") ? graphsProductivity[queryParams.get("productivity-goals-id")] : graphs[goalsId]

    const [code, setCode] = useState('');

    const generateCode = () => {
        const letter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
        const numbers = Math.floor(1000 + Math.random() * 9000);
        setCode(letter + numbers);
    };

    useEffect(() => {
        generateCode();
    }, [])

    const productivityGoalsId = queryParams.get('productivity-goals-id');
    const goals = queryParams.get('goals-value') ? queryParams.get('goals-value').split(',') : [];
    const productivityGoals = queryParams.get('productivity-goals') ? queryParams.get('productivity-goals').split(',') : [];

    
    const decryptName = decryptText(queryParams.get('un') || "") || "";

    return (
        <div className="page predict page--without-button">
            <PageContent>
                <div className="page-content">
                    <p className="text" style={{ marginBottom: '12rem' }}>
                        {decryptName ? `${decryptName}, your setup #${businessProfiles?.data?.code ?? code} is ready!` : `Your setup #${businessProfiles?.data?.code ?? code} is ready!`}
                    </p>
                    <CustomTitle
                        style={{ marginBottom: '32rem' }}
                        title={title}
                    />

                    <div className="predict-item">
                        <div className="predict-item-top">
                            <span>{graphTitle}</span>
                            <span>Goal: {graphGoal}</span>
                        </div>
                        {graph}
                        <div className="predict-item-bottom">
                            <span>Now</span>
                            <span>{weeksToAdd}</span>
                        </div>
                    </div>

                    <ul className="plan-list" style={{ marginTop: '24rem' }}>
                        {productivityGoalsId ?
                            <>{(productivityGoals.includes('0')) && (
                                <li>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.5 7.08068L6.92298 10.1614L13.7689 4" stroke="#4DCC8C" stroke-width="2.2885" stroke-linecap="round" />
                                    </svg>
                                    Generate more video ads
                                </li>
                            )}
                                {(productivityGoals.includes('1')) && (
                                    <li>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.5 7.08068L6.92298 10.1614L13.7689 4" stroke="#4DCC8C" stroke-width="2.2885" stroke-linecap="round" />
                                        </svg>
                                        Lower video ad production costs
                                    </li>
                                )}
                                {(productivityGoals.includes('2')) && (
                                    <li>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.5 7.08068L6.92298 10.1614L13.7689 4" stroke="#4DCC8C" stroke-width="2.2885" stroke-linecap="round" />
                                        </svg>
                                        Generate more static ads
                                    </li>
                                )}

                                {(productivityGoals.includes('3')) && (
                                    <li>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.5 7.08068L6.92298 10.1614L13.7689 4" stroke="#4DCC8C" stroke-width="2.2885" stroke-linecap="round" />
                                        </svg>
                                        Reduce static ad production costs
                                    </li>
                                )}
                                {(productivityGoals.includes('4')) && (
                                    <li>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.5 7.08068L6.92298 10.1614L13.7689 4" stroke="#4DCC8C" stroke-width="2.2885" stroke-linecap="round" />
                                        </svg>
                                        Launch more ad campaigns
                                    </li>
                                )}
                                {(productivityGoals.includes('5')) && (
                                    <li>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.5 7.08068L6.92298 10.1614L13.7689 4" stroke="#4DCC8C" stroke-width="2.2885" stroke-linecap="round" />
                                        </svg>
                                        Cut ad campaign expenses
                                    </li>
                                )}
                            </> :
                            <>{(goals.includes('0') || goals.length === 0) && (
                                <li>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.5 7.08068L6.92298 10.1614L13.7689 4" stroke="#4DCC8C" stroke-width="2.2885" stroke-linecap="round" />
                                    </svg>
                                    Increase purchases amount
                                </li>
                            )}
                                {(goals.includes('2') || goals.length === 0) && (
                                    <li>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.5 7.08068L6.92298 10.1614L13.7689 4" stroke="#4DCC8C" stroke-width="2.2885" stroke-linecap="round" />
                                        </svg>
                                        Boost ROAS (return on ad spend)
                                    </li>
                                )}
                                {(goals.includes('1') || goals.length === 0) && (
                                    <li>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.5 7.08068L6.92298 10.1614L13.7689 4" stroke="#4DCC8C" stroke-width="2.2885" stroke-linecap="round" />
                                        </svg>
                                        Lower CPA (cost per action)
                                    </li>
                                )}

                                {(goals.includes('3') || goals.length === 0) && (
                                    <li>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.5 7.08068L6.92298 10.1614L13.7689 4" stroke="#4DCC8C" stroke-width="2.2885" stroke-linecap="round" />
                                        </svg>
                                        Grow CTR (click through rate)
                                    </li>
                                )}
                            </>
                        }
                    </ul>
                </div>
            </PageContent>
            <div className="block-button">
                <MyButton
                    onClick={() => {
                        if (!businessProfiles?.data?.code) {
                            queryParams.set('setup-number', code);
                        }
                        trackP1Event('onboarding_predict', {})
                        history.push({
                            pathname: '/summary-proof',
                            search: `?${queryParams.toString()}`
                        });
                    }}
                    buttonIcon={''}
                    buttonText={`Get access to AI copilot`}></MyButton>
            </div>

        </div>
    )
}
